import React from "react"

import { OperatorInterface } from "./constants"

export const importView = (operator: OperatorInterface, componentName: string) =>
React.lazy(() =>
    // First we try to import the file from the oprator
    import(`operators/${operator.folderName}/components/${componentName}${operator.name}`)
    // Then we had a "default export" for the component
    // https://dev.to/iamandrewluca/react-lazy-without-default-export-4b65
        .then((module) => ({ default: module[`${componentName}${operator.name}`] }))
        .catch(() =>
            // If no file exists (no custom for the operator), we pass the default operator
            import(`operators/default/components/${componentName}Default`).then((module) => ({
                default: module[`${componentName}Default`],
            }))
        )
)